import React from 'react';
import { Toaster } from 'react-hot-toast';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Stats from './components/Stats';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-ferry-dark">
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#2A2A2A',
            color: '#FFFFFF',
            border: '1px solid rgba(155, 35, 53, 0.3)',
          },
        }}
      />
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Stats />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
